import { Box, Collapse, Loader } from '@wix/design-system';
import { Edit } from '@wix/wix-ui-icons-common';
import React, { useEffect, useRef } from 'react';
import { dataHooks } from '../../utils/datahooks';
import { focusFirstDescendant } from '../../utils/focus-first-element';
import { usePreviousState } from '../../utils/use-previous-state';
import { wdsThemeColors } from '../../utils/wds-theme-colors';
import { HoverStyledBox } from '../hover-styled-box/hover-styled-box';
import { PrefixStatusIcon } from './prefix-status-icon';
export const RuleElement = _ref => {
  let {
    headerComponent,
    contentComponent,
    status,
    isOpen,
    onClick,
    onStatusChange,
    dataHook,
    iconButtonToolTip,
    iconButtonPriority,
    iconButtonSkin,
    prefixStatusIconTooltip,
    iconButtonAriaLabel,
    width = 'normal',
    disabled = false,
    isLoading = false,
    onShowPrefixIconTooltip,
    autoFocus = false,
    showIconButton = true,
    headerSuffix,
    notHoveredBorderColor = wdsThemeColors.borderStandard,
    hoveredBorderColor = wdsThemeColors.borderFocus,
    hoveredBackgroundColor = 'B60'
  } = _ref;
  const prevStatus = usePreviousState(status);
  const contentRef = useRef(null);
  useEffect(() => {
    if (prevStatus !== undefined && prevStatus !== status) {
      onStatusChange == null || onStatusChange();
    }
  }, [onStatusChange, prevStatus, status]);
  const focusFirstElement = () => {
    if (contentRef.current) {
      focusFirstDescendant(contentRef.current);
    }
  };
  const isShowIconButton = showIconButton && !isOpen;
  const contentId = `${dataHook}-content`;
  return /*#__PURE__*/React.createElement(HoverStyledBox, {
    ariaControls: contentId,
    ariaExpanded: isOpen,
    ariaLabel: iconButtonAriaLabel,
    autoFocus: autoFocus,
    dataHook: dataHooks.ruleElementHoverBox(dataHook),
    disabled: disabled,
    hoveredBackgroundColor: hoveredBackgroundColor,
    hoveredBorderColor: hoveredBorderColor,
    iconButton: isShowIconButton ? /*#__PURE__*/React.createElement(Edit, {
      "aria-label": iconButtonAriaLabel
    }) : undefined,
    iconButtonPriority: iconButtonPriority,
    iconButtonSkin: iconButtonSkin,
    iconButtonTooltip: iconButtonToolTip,
    iconButtonZIndex: 3,
    isOpen: isOpen,
    isShowIconButton: isShowIconButton,
    notHoveredBorderColor: notHoveredBorderColor,
    width: width,
    onClick: !isOpen ? onClick : undefined,
    onClickIcon: isOpen ? undefined : onClick
  }, /*#__PURE__*/React.createElement(Box, {
    borderRadius: "6px",
    dataHook: dataHooks.ruleElementBorderBox(dataHook),
    direction: "vertical",
    gap: isOpen ? 'SP3' : '0',
    overflow: "hidden",
    padding: isOpen ? 'SP2 SP3 SP3 SP3' : 'SP2 SP3',
    verticalAlign: "top",
    width: "100%"
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      cursor: isOpen ? 'pointer' : undefined
    },
    onClick: isOpen ? onClick : undefined
  }, /*#__PURE__*/React.createElement(Box, {
    flexShrink: 0,
    gap: "SP1",
    verticalAlign: "middle"
  }, /*#__PURE__*/React.createElement(Box, {
    margin: "SP1 SP1 SP1 0",
    verticalAlign: "middle"
  }, isLoading ? /*#__PURE__*/React.createElement(Loader, {
    size: "tiny"
  }) : status ? /*#__PURE__*/React.createElement(PrefixStatusIcon, {
    dataHook: dataHook,
    prefixStatusIconTooltip: prefixStatusIconTooltip,
    status: status,
    onShowTooltip: onShowPrefixIconTooltip
  }) : null), /*#__PURE__*/React.createElement(Box, {
    flex: "1"
  }, headerComponent), headerSuffix)), /*#__PURE__*/React.createElement(Collapse, {
    dataHook: dataHooks.ruleElementCollapse(dataHook),
    open: isOpen,
    onExpandAnimationEnd: focusFirstElement
  }, /*#__PURE__*/React.createElement("div", {
    id: contentId,
    ref: contentRef,
    tabIndex: -1
  }, contentComponent))));
};
//# sourceMappingURL=rule-element.js.map